import { MetaData } from 'store/remoteConfig/types';
import { platformNames } from 'shared/constants';

const PD_META_TITLE = 'Buy Product_Name Online in UAE at Best Prices | Nysaa';
const PD_META_DESCRIPTION =
  'Explore Product_Name by Nysaa. Perfect for your daily makeup or skincare routine. Shop online in UAE for fast delivery.';
const BP_META_TITLE =
  'Buy Brand_Name Products Online in UAE at Best Prices | Nysaa';
const BP_META_DESCRIPTION =
  'Shop Brand_Name collection online in the UAE from Nysaa. Explore wide range of style & designs with convenience of COD and easy returns!';
const SEARCH_META_TITLE =
  'Discover Trending Makeup, Skincare, & Fragrances Brands Online in UAE at Nysaa';
const SEARCH_META_DESCRIPTION =
  'Buy makeup, skincare, haircare, and fragrances at Nysaa – the leading online destination for top beauty brands in the UAE. Shop premium products at your fingertips!';

export const DEFAULT_META: MetaData = {
  productPage: {
    title: PD_META_TITLE,
    description: PD_META_DESCRIPTION,
  },
  brandPage: {
    title: BP_META_TITLE,
    description: BP_META_DESCRIPTION,
  },
  searchPage: {
    title: SEARCH_META_TITLE,
    description: SEARCH_META_DESCRIPTION,
    keywords:
      'Nysaa, a, Nysaa.com, Nisa, Nyysa, a.com, Nysaa online, Nysaa UAE, buy cosmetics online, cosmetics online, buy beauty products online, beauty products online, buy cosmetics UAE, buy beauty products UAE',
    canonical: 'http://www.nysaa.com/search/result',
  },
  storesNEventsPage: {
    title: SEARCH_META_TITLE,
    description: SEARCH_META_DESCRIPTION,
  },
};

export const favicon = {
  [platformNames.NYKAA]:
    '//ne-nysaa-prod-fe-static-assets.nysaa.com/favicon/favicon.svg',
  // [platformNames.NYKAA]:
  //   '//images-static.naikaa.com/media/wysiwyg/uiTools/2024-3/beauty.png',
  [platformNames.MEN]:
    '//images-static.naikaa.com/media/wysiwyg/uiTools/2025-3/favicon_nykaaman.jpg',
};

export const appleTouchIcon = {
  [platformNames.MEN]: '//images-static.nykaa.com/media/Men_App_512.png',
};
